export default __webpack_public_path__ + "static/media/title.71603466.png";